import React from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { sdmTableStyles, getHeaderCellStyle } from "./sdmTableStyles";

const GuarantorsTable = ({ data, onChange }) => {
  const rows = data || [];

  const handleCellChange = (rowIndex, field, value) => {
    const updatedRows = rows.map((row, index) => {
      if (index === rowIndex) {
        return { ...row, [field]: value };
      }
      return row;
    });
    onChange(updatedRows);
  };

  const handleAddRow = () => {
    const newRow = {
      name: "",
      whoIsGuarantor: "",
      guarantorProperty: ""
    };
    onChange([...rows, newRow]);
  };

  const handleDeleteRow = (rowIndex) => {
    const updatedRows = rows.filter((_, index) => index !== rowIndex);
    onChange(updatedRows);
  };

  const columns = [
    { label: "Наименование поручителя", minWidth: 200 },
    { label: "Кем поручитель является в бизнесе", minWidth: 200 },
    { label: "Какое имущество есть у поручителя", minWidth: 250 },
  ];

  return (
    <Box sx={sdmTableStyles.tableWrapper}>
      <Box sx={sdmTableStyles.headerSection}>
        <Box sx={sdmTableStyles.sectionTitle}>
          Кто может выступить поручителем
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={sdmTableStyles.tableContainer}
      >
        <Table size={sdmTableStyles.tableSize}>
          <TableHead>
            <TableRow sx={sdmTableStyles.headerRow}>
              {columns.map((headCell, index) => (
                <TableCell
                  key={index}
                  sx={getHeaderCellStyle(headCell.minWidth)}
                >
                  {headCell.label}
                </TableCell>
              ))}
              <TableCell sx={sdmTableStyles.emptyCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex} sx={sdmTableStyles.dataRow}>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.name || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'name', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.whoIsGuarantor || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'whoIsGuarantor', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.guarantorProperty || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'guarantorProperty', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <IconButton
                    size="small"
                    onClick={() => handleDeleteRow(rowIndex)}
                    sx={sdmTableStyles.deleteButton}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={4} sx={sdmTableStyles.addRowCell}>
                <Button
                  fullWidth
                  onClick={handleAddRow}
                  startIcon={<AddCircleIcon />}
                  sx={sdmTableStyles.addRowButton}
                >
                  Добавить строку
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default GuarantorsTable;
